
import "./PaginationCore/PaginationCore.st.css.js";
import "../common/Focusable/Focusable.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_178_0_Pagination";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_178_0_Pagination__root","text-small-thin":"wds_1_178_0_StylableTypography__text-small-thin","button-common-mixin":"wds_1_178_0_Pagination__button-common-mixin","pagination":"wds_1_178_0_Pagination__pagination","arrow":"wds_1_178_0_Pagination__arrow"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




